function change_url_boleto() {
    var login = $('#login_user').text();
    var senha = $('#senha_user').text();

    var month = $("select[name='mes_cobranca']").val();
    var year = $("select[name='ano_cobranca']").val();

    var pathname = window.location.pathname; // Returns path only
    var url = window.location.href.split('?')[0];

    var new_url = url + '?login=' + login + '&senha=' + senha + '&mes_cobranca=' + month + '&ano_cobranca=' + year;
    window.location.href = new_url;
}

$(document).ready(function () {
    $("select[name='mes_cobranca']").on('change', function () {
        change_url_boleto();
    });
});
